<template>
  <UContainer v-if="facetsData" class="my-12">
    <TText
      v-if="facetsData.title && facetsData.seoEnhancedText"
      size="lg"
      tag="h2"
      variant="semibold"
      classes="mb-4"
    >
      {{ facetsData.title }}
    </TText>
    <div
      v-if="facetsData.seoEnhancedText"
      v-html="facetsData.seoEnhancedText"
    ></div>
  </UContainer>
</template>

<script setup lang="ts">
import type { schemaType as FacetsSchemaType } from '~~/modules/api/rurality/v3/search/seo/facet/schema'

defineProps<{
  facetsData?: FacetsSchemaType
}>()
</script>
